export const SEO_TYPE = {
  DOL: 'DOL',
  SOCIAL: 'SOCIAL',
  GOOGLE: 'GOOGLE',
};

export const FORM_GROUP_NAME = {
  BASIC_FORM_INFO: 'basicInfoFormGroup',
  COMMON_FORM_INFO: 'commonInfoFormGroup',
  LANDING_FORM_INFO: 'landingInfoFormGroup',
  SOCIAL_FORM_INFO: 'socialInfoFormGroup',
  GOOGLE_FORM_INFO: 'googleInfoFormGroup',
  SCHEMA_FORM_INFO: 'schemaFormGroup',
  BLOG_DETAIL_FORM_INFO: 'blogDetailInfoFormGroup',
  TEST_DETAIL_FORM_INFO: 'testDetailInfoFormGroup',
};

export const Author = {
  DOL_IELTS_DINH_LUC: 'DOL IELTS Đình Lực',
  DOL: 'DOL',
} as const;

export type Author = (typeof Author)[keyof typeof Author];

export const TimeToRead = {
  TWO_MINS: '2 mins read',
  FIVE_MINS: '5 mins read',
  GREATER_THAN_TEN_MINS: '> 10 mins read',
} as const;
export type TimeToRead = (typeof TimeToRead)[keyof typeof TimeToRead];
